<template>
  <v-dialog v-bind="computedProps" v-on="computedListeners" v-model="showDialog">
    <v-card min-height="80%" min-width="80%">
      <v-toolbar elevation="2" color="primary" dark dense>
        <v-spacer/>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid class="px-5 ma-0">

          <v-row no-gutters>
            <v-col :xs="5" :sm="5" :md="5" :lg="2" :xl="2" :cols="5" class="px-1">
              <span class="search-number">{{ itemList.length }}</span>件 の検索結果
            </v-col>
            <v-col :xs="7" :sm="7" :md="7" :lg="4" :xl="4" :cols="7" v-if="!abbreviatedDisplay">
              <a
                class="condition-clear-bottom"
                @click="onClearButtonClick">
                条件をクリア
              </a>
            </v-col>
            <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="mt-2" v-if="!abbreviatedDisplay">
              <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
            </v-col>
            <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="px-1">
              <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="searchText"/>
            </v-col>
          </v-row>

          <hr class="section-line mb-2">

          <v-row no-gutters justify="end" v-if="!abbreviatedDisplay">
            <v-col :cols="6">
              <dd-transparent-button
                v-if="(targetMaster)"
                :minWidth="265"
                tooltipText="ここからマスタデータの新規登録が実行できます。<br>※別画面で起動します。"
                :tooltipTop="true"
                :enableToolTip="helpUseFlg"
                @click="onAddMaster()">
                <v-icon color="#1F2B38">mdi-plus-circle</v-icon>新たにマスタデータを追加する場合はこちら
              </dd-transparent-button>
            </v-col>
            <v-col :cols="6">
              <v-row no-gutters justify="end">
                <dd-select-items-per-page
                  ref="pagination1"
                  :itemsPerPage.sync="itemsPerPage"
                  :currentPage.sync="page"
                  :items="itemList"
                  @changeItemsPerPage="changeItemsPerPage"
                  @changePage="changePage"
                />
              </v-row>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-data-table
              item-key="torisakiCd"
              :headers="headers"
              :items="itemList"
              :search="searchText"
              :items-per-page="itemsPerPage"
              :page.sync="page"
              @dblclick:row="onRowDoubleClick"
              no-data-text="対象データはありません"
              fixed-header
              :hide-default-header="abbreviatedDisplay"
              hide-default-footer
              locale="ja-jp"
              dense
            >
              <template v-slot:[`item.actions`]="{item}">
                <template>
                  <v-chip
                    small
                    color="primary"
                    @click="onRowSelectButtonClick(item)"
                  >
                    選択
                  </v-chip>
                </template>
              </template>
              <template v-slot:item="{ item }" v-if="abbreviatedDisplay">
                <tr>
                  <td rowspan="1" style="width:20px" class="px-0 rireki-td">
                    <v-chip
                      small
                      color="primary"
                      @click="onRowSelectButtonClick(item)"
                    >
                      選択
                    </v-chip>
                  </td>
                  <!--営業所マスタ検索用-->
                  <template v-if="targetMaster === 'eigyosho'">
                    <td colspan="2" class="wrap-text rireki-td">
                      <div class="row-line">
                        <span class="label">営業所コード：</span>
                        <span class="value">{{ item.eigyoshoCd }}</span>
                      </div>
                      <div class="row-line">
                        <span class="label">営業所名称：</span>
                        <span class="value">{{ item.eigyoshoNm }}</span>
                      </div>
                    </td>
                  </template>
                  <!--取引先マスタ検索用-->
                  <template v-if="targetMaster === 'torihikisaki'">
                    <td colspan="2" class="wrap-text rireki-td">
                      <div class="row-line">
                        <span class="label">取引先コード：</span>
                        <span class="value">{{ item.torihikisakiCd }}</span>
                      </div>
                      <div class="row-line">
                        <span class="label">取引先名称：</span>
                        <span class="value">{{ item.torihikisakiNm }}</span>
                      </div>
                    </td>
                  </template>
                </tr>
              </template>
            </v-data-table>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-row no-gutters class="px-1 py-0 mt-3" v-if="itemList.length > 0">
          <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12">
            <dd-transparent-button :minWidth="120" @click="onCloseClick">
              <v-icon color="#1F2B38">mdi-close-circle</v-icon>ヘルプを閉じる
            </dd-transparent-button>
          </v-col>
          <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12" v-if="!abbreviatedDisplay">
            <v-row no-gutters justify="end">
              <dd-select-items-per-page
                ref="pagination2"
                :itemsPerPage.sync="itemsPerPage"
                :currentPage.sync="page"
                :items="itemList"
                @changeItemsPerPage="changeItemsPerPage"
                @changePage="changePage"
              />
            </v-row>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdTransparentButton from '@/components/DdTransparentButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'

import { mapGetters } from 'vuex'
import controls from '@/rahmen/controls'

/**
 * @file DDv2用マスタ検索用ダイアログ
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [showDialog=false] - ダイアログ表示可否
 * @vue-prop {Array} headerList - ダイアログ用ヘッダリスト
 * @vue-prop {Array} itemList - オートコンプリート用リスト
 * @vue-prop {String} titleText - ダイアログ用表示タイトル
 * @see DdCodeTextBox
 * @example
    <dd-master-search-dialog
      :showDialog="showDialog"
      :titleText="titleText"
      :headerList="headerList"
      :itemList="itemList"
      [atmark]close="onDialogClosed"/>
 */
export default {
  name: 'DdMasterSearchDialogChild',
  components: {
    DdTransparentButton,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 一覧内容
     */
    itemList: Array,
    /**
     * ヘッダー設定
     */
    headerList: Array,
    /**
     * ダイアログタイトル
     */
    titleText: String,
    /**
     * 対象マスタ
     */
    targetMaster: String,
    abbreviatedDisplay: {
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      type: Number,
      default: 25
    }
  },
  data: () => ({
    title: '',
    searchText: '',
    ctypes: controls,
    headers: [],
    // 一覧選択用
    actionDefine: { text: '', value: 'actions', align: 'center' },
    // 一覧制御用
    selected: [],
    page: 1
  }),
  created () {
  },
  mounted () {
    this.title = this.titleText
    this.headers = Object.assign([], this.headerList)
    // 先頭に選択ボタンを追加
    this.headers.splice(0, 0, this.actionDefine)
  },
  computed: {
    ...mapGetters({
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        scrollable: true,
        maxWidth: '80%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    rowCount () {
      return this.itemList.length
    }
  },
  methods: {
    onClearButtonClick () {
      this.searchText = ''
      this.page = 1

      // ページャ2つを同期しているならここも合わせる
      this.$nextTick().then(() => {
        if (this.$refs.pagination1) this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        if (this.$refs.pagination2) this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    onRowDoubleClick: function (e, f) {
      console.log('onRowDoubleClick', e, f)
      /**
       * 選択時クローズ処理
       * @event close
       * @type {Event}
       */
      this.$emit('close', f.item)
    },
    onRowSelectButtonClick: function (item) {
      console.log('onRowSelectButtonClick', item)
      this.$emit('close', item)
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event close
       * @type {Event}
       */
      this.$emit('close', undefined)
    },
    onAddMaster: function () {
      var path = location.href
      path = path.substring(0, path.indexOf('#/'))
      var url = path + '#/mst/' + this.targetMaster + '/edit/0'
      window.open(url, '_blank')
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 700 !important;
}
</style>
